import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
/**
 * Framework-agnostic hook for reading URL search parameters
 * Works with Next.js, Vite, and other React applications
 */
export function useSearchParams() {
  const $ = _c(2);
  const [searchParams, setSearchParams] = useState(_temp);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (typeof window !== "undefined") {
        const params = new URLSearchParams(window.location.search);
        setSearchParams(params);
        const handlePopState = () => {
          setSearchParams(new URLSearchParams(window.location.search));
        };
        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return searchParams;
}
/**
 * Framework-agnostic navigation utility
 * Works with Next.js, Vite, and other React applications
 */
function _temp() {
  if (typeof window !== "undefined") {
    return new URLSearchParams(window.location.search);
  }
  return new URLSearchParams();
}
export function useRouter() {
  const push = url => {
    if (typeof window !== "undefined") {
      // For client-side routing frameworks, we should use history.pushState
      // This will work for most SPA frameworks
      window.history.pushState({}, "", url);
      // Dispatch a custom event that components can listen to
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  };
  return {
    push
  };
}
/**
 * Direct utility function for getting search params without a hook
 * Useful for server-side or one-time usage
 */
export function getSearchParams() {
  if (typeof window !== "undefined") {
    return new URLSearchParams(window.location.search);
  }
  return null;
}